import React, { forwardRef, useEffect, useState } from 'react';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

import { CloseIcon } from '../../../components/icon/ErrorShapeIcon';
import { AlertWarningIcon } from '../../../components/icon/ShapeAlertWarning';

const useStyles = makeStyles(theme => ({
  alert: {
    backgroundColor: theme.palette.semiTransparentWhite,
    '& .MuiAlert-icon': {
      color: theme.palette.warning.main,
    },
    alignItems: 'center',
    margin: props => props.customMargin,
  },
  alertIcon: {
    margin: '0 1.5rem 0 0.5rem',
  },
  closeIcon: {
    margin: '0 0.5rem 0 0',
    cursor: 'pointer',
    borderRadius: '50%',
    transition:
      'background-color 0.3s ease, color 0.3s ease, transform 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.common.white,
      transform: 'scale(1.1)',
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  message: {
    flex: 1,
    color: theme.palette.goldenYellow,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
  },
  link: {
    cursor: 'pointer',
    color: theme.palette.lightBlue,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const BannerEmployee = forwardRef(
  (
    {
      onClose,
      onClickHere,
      message,
      linkText,
      severity = 'warning',
      customMargin = '1.5rem 0.3rem 1rem 1.8rem',
    },
    ref
  ) => {
    const classes = useStyles({ customMargin });
    const [show, setShow] = useState(false);

    useEffect(() => {
      setShow(true);
    }, []);

    const handleClose = () => {
      setShow(false);
      setTimeout(() => {
        if (onClose) onClose();
      }, 300);
    };

    return (
      <Collapse in={show} timeout={300} ref={ref}>
        <Alert
          severity={severity}
          className={classes.alert}
          icon={
            <AlertWarningIcon
              width="25px"
              height="25px"
              className={classes.alertIcon}
            />
          }
          action={
            <CloseIcon onClick={handleClose} className={classes.closeIcon} />
          }
        >
          <Box className={classes.content}>
            <span className={classes.message}>
              {message}{' '}
              <Link
                component="button"
                onClick={onClickHere}
                className={classes.link}
              >
                {linkText}
              </Link>{' '}
            </span>
          </Box>
        </Alert>
      </Collapse>
    );
  }
);

export default BannerEmployee;
